import React, {Component} from 'react';
import {connect} from 'react-redux';
import config from 'config';

import Spinner from 'spinner';

import {Link} from 'react-router-dom';
import Breadcrumbs from 'components/breadcrumbs';

import Box from 'components/box';
import {PageHead} from 'components/header/components';
import {ButtonSuccessModal, ButtonDangerModal, ButtonWrap} from 'components/buttons';
import {Image, Meta, Head, Content, Gallery, ImagesSection} from 'system/news/components';

import ActionsList from './detail/actions-list';

import ReactModal from 'react-modal';
import {Modal, CloseModal, ModalContent, ModalImage} from 'components/modal';

import {loadNewsDetail, loadTagsByNewsDetail, loadContentByNews, changeNewsValue, deleteNews, deleteImage } from 'redux/actions/portal/news';

import close from 'images/general/close.svg';
import deletePick from 'images/general/deletePick.svg';
import news from 'images/general/news.svg';

const mapStateToProps = state => ({
  detail: state.news.get('newsDetail'),
  tags: state.news.get('tagsByNews'),
  tagsAreLoading: state.news.get('tagsByNewsAreLoading'),

  images: state.news.get('newsContent'),
  isFetching: state.news.get('newsAreLoading'),
  contentIsLoading: state.news.get('contentByNewsIsLoading')
}); 

const mapDispatchToProps = dispatch => ({
  onLoad: (id) => {
    dispatch(loadNewsDetail(id))
    dispatch(loadTagsByNewsDetail(id))
    dispatch(loadContentByNews(id))
  },
  deleteNews: (id) => dispatch(deleteNews(id)),
  changeValue: (value, key) => dispatch(changeNewsValue(value, key)),
  deleteImage: (id, news_id) => dispatch(deleteImage(id, news_id))
});

class NewsDetail extends Component {

  
  constructor(props) {
    super(props);

    this.state = {
        image: null,
      modalOpen: false,
      deleteModalOpen: false,
      deleteModalOpenImage: false,
      image_id: null,
      news_id: null
    }
    this.toggleDeleteModal = this.toggleDeleteModal.bind(this);
    this.toggleDeleteModalImage = this.toggleDeleteModalImage.bind(this);
  }

  toggleDeleteModal(event) {
    this.setState({
      deleteModalOpen: !this.state.deleteModalOpen
    });
  }

  toggleDeleteModalImage(event, image_id, news_id) {
    this.setState({
      deleteModalOpenImage: !this.state.deleteModalOpenImage,
      image_id: image_id,
      news_id: news_id
    });
  }

  onToggleModal(image) {
    this.setState({
      modalOpen: !this.state.modalOpen,
      image: image
    })
  }

  onModalOk = () => {
    this.toggleDeleteModalImage()
    this.props.deleteImage(this.state.image_id, this.state.news_id)
  }

  renderDatePublished = date => {
    return date
      ? new Date(date).toLocaleString('uk-UA', config.options)
      : 'Не опубліковано'
  }


  componentDidMount() {
    this.props.onLoad(this.props.match.params.id);
  }


  render() {

    const {detail, isFetching, images, tags} = this.props;

    if (!detail || !images || !images.get('results') || !tags.get('results')) {
      return <Spinner />
    }

    if (this.props.isFetching ){
      return <Spinner/>
    }

    if (this.props.tagsAreLoading){
      return <Spinner/>
    }


    return (
      <div>
          <Breadcrumbs>
              <li><Link to="/admin/">Головна</Link></li>
              <li><Link to="/admin/news">Новини</Link></li>
              <li><Link to={`/admin/news/detail/${detail.get('id')}`}>Новина № {detail.get('id')}</Link></li>
          </Breadcrumbs>
        {isFetching ? (
          <Spinner />
        ):(

      <Box>
         <PageHead>
          <h2>{detail.get('title')}</h2>
        </PageHead>

           
          <Box title4="Дії з новиною:">
            <ActionsList
              id={this.props.match.params.id}
              toggleDeleteModal={this.toggleDeleteModal}
              changeValue={(value, key) => this.props.changeValue(value, key)}
              detail={this.props.detail}
            />
          </Box>
        
            <Image>
              <img src={detail.get('image') ? detail.get('image') : news} alt="news" />
            </Image>
            <Meta>
              <span style={{marginLeft: "0"}}>{this.renderDatePublished(detail.get('date_published'))}</span>
           {this.props.tags.get('results').size > 0 ? (
                this.props.tags.get('results').map((tag, i) => (
                  <span key={i}>{tag.get('tag_data').get('title')}</span>
                ))
           ):(
            null
           )}
            </Meta>
            <Head>
              <h4 style={{color: "#000"}}>{detail.get('title')}</h4>
            </Head>
            <Content>
              <p dangerouslySetInnerHTML={{
                __html: detail.get('detail_description')
              }}></p>
            </Content>
                
            {this.props.detail.get('current_status') === "draft" ? (
              <ImagesSection>
              <h2>Галерея новин:</h2>
              <Gallery>
                {images.get('results').size > 0 ? (
                  images.get('results').map((image, id) => (
                    <li onClick={() => this.onToggleModal(image.get('file'))} key={image.get('id')}><img src={image.get('file')} alt={image.get('name')}/> <div style={{
                      backgroundImage: `url(${deletePick})`, backgroundSize: "cover ", backgroundRepeat: "no-repeat", backgroundPosition: "center"
                    }} onClick={(e) => {
                      e.stopPropagation()
                      this.toggleDeleteModalImage(e, image.get('id'), image.get('news'))
                    }}></div></li>
                  ))
                ):(
                  <h4>Прикріплені зображення відсутні</h4>
                )}
              </Gallery>
            </ImagesSection>
            ): (
              <ImagesSection>
              <h2>Галерея новин:</h2>
              <Gallery>
                {images.get('results').size > 0 ? (
                  images.get('results').map((image, id) => (
                    <li onClick={() => this.onToggleModal(image.get('file'))} key={image.get('id')}><img src={image.get('file')} alt={image.get('name')}/></li>
                  ))
                ):(
                  <h4>Прикріплені зображення відсутні</h4>
                )}
              </Gallery>
            </ImagesSection>
            )}
      </Box>
      
        )}
      <ReactModal isOpen={this.state.modalOpen} onRequestClose={this.onToggleModal}
        className={{
          base: 'modalGallery',
          afterOpen: 'myClass_after-open',
          beforeClose: 'myClass_before-close'
        }} contentLabel="Підтвердження запису"
        overlayClassName={{
          base: 'modalOverlay',
          afterOpen: 'myOverlayClass_after-open',
          beforeClose: 'myOverlayClass_before-close'
        }}>
        <Modal>
          <CloseModal>
            <div onClick={this.onToggleModal}>
               <img src={close} alt="закрити" />
            </div>
          </CloseModal>
          <ModalContent>
            <ModalImage>
              <img src={this.state.image} alt="" />
            </ModalImage>
          </ModalContent>
        </Modal>
      </ReactModal>

          <ReactModal isOpen={this.state.deleteModalOpen} onRequestClose={this.toggleDeleteModal}
          className={{
            base: 'modalContent',
            afterOpen: 'myClass_after-open',
            beforeClose: 'myClass_before-close'
          }} contentLabel="Підтвердження видалення"
          overlayClassName={{
            base: 'modalOverlay',
            afterOpen: 'myOverlayClass_after-open',
            beforeClose: 'myOverlayClass_before-close'
          }}>

          <div>
          <Modal>
            <CloseModal>
              <div>
				         <img src={close} alt="закрити" onClick={this.toggleDeleteModal} />
              </div>
						</CloseModal>
            <ModalContent>
              <h3>Ви впевнені, що хочете видалити новину "{detail.get('title')}"?</h3>

              <ButtonWrap>
                <ButtonSuccessModal onClick={(id) => this.props.deleteNews(this.props.match.params.id)} value="Так"/>
                <ButtonDangerModal value="Ні" onClick={this.toggleDeleteModal}/>
              </ButtonWrap>
            </ModalContent>
          </Modal>
          </div>

        </ReactModal>


         <ReactModal isOpen={this.state.deleteModalOpenImage} onRequestClose={this.toggleDeleteModalImage}
          className={{
            base: 'modalContent',
            afterOpen: 'myClass_after-open',
            beforeClose: 'myClass_before-close'
          }} contentLabel="Підтвердження видалення"
          overlayClassName={{
            base: 'modalOverlay',
            afterOpen: 'myOverlayClass_after-open',
            beforeClose: 'myOverlayClass_before-close'
          }}>

          <div>
          <Modal>
            <CloseModal>
              <div>
				         <img src={close} alt="закрити" onClick={this.toggleDeleteModalImage} />
              </div>
						</CloseModal>
            <ModalContent>
              <h3>Ви впевнені, що хочете видалити це зображення?</h3>

              <ButtonWrap>
                <ButtonSuccessModal onClick={this.onModalOk} value="Так"/>
                <ButtonDangerModal value="Ні" onClick={this.toggleDeleteModalImage}/>
              </ButtonWrap>
            </ModalContent>
          </Modal>
          </div>

        </ReactModal>

      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NewsDetail);



// WEBPACK FOOTER //
// ./src/admin/news/detail.js